import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import EducationDetail from "./EducationDetail";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import { Grid } from "@mui/material";
import AllSchoolRoles from "./AllRoles";

const tabs = [
  { label: "School Details", value: "ed_school_detail" },
  { label: "Create Roles", value: "ed_create_role" },
]; //education_settings

const EducationSetting = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, education_settings: tab }));
  };
  return (
    <NavigationDrawer>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Settings*"}
            tabs={tabs}
            activeTab={activeTab.education_settings}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.education_settings === "ed_school_detail" ? (
            <EducationDetail />
          ) : activeTab.education_settings === "ed_create_role" ? (
            <AllSchoolRoles />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default EducationSetting;
